import { Icon } from '@chakra-ui/react';

export default function SFPlusCircleIcon(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width={4}
      height='16.4'
      viewBox='0 0 16 16.4'
      fill='currentColor'
      {...props}
    >
      <path d='M8 16.328c-4.352 0-7.969-3.617-7.969-7.969C.031 4 3.641.391 7.992.391 12.352.39 15.97 4 15.97 8.359c0 4.352-3.61 7.97-7.969 7.97M8 15a6.615 6.615 0 0 0 6.64-6.64 6.62 6.62 0 0 0-6.648-6.641 6.6 6.6 0 0 0-6.625 6.64A6.61 6.61 0 0 0 8 15M4.375 8.36c0-.391.266-.665.664-.665h2.297V5.398c0-.398.266-.671.648-.671.391 0 .664.273.664.671v2.297h2.305c.39 0 .664.274.664.664 0 .383-.273.641-.664.641H8.648v2.305c0 .398-.273.664-.664.664-.382 0-.648-.274-.648-.664V9H5.039c-.398 0-.664-.258-.664-.64' />
    </Icon>
  );
}
